import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import * as RadixDropdownMenu from "@radix-ui/react-dropdown-menu";
import { memo } from "react";
export const DropdownMenuSeparator = /*#__PURE__*/ memo((param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(RadixDropdownMenu.Separator, {
        className: tailwindMerge("-mx-2 h-px shrink-0 bg-grey-4", className),
        "data-testid": "DROPDOWN_MENU_SEPARATOR",
        ...restOfProps
    });
});
DropdownMenuSeparator.displayName = "DropdownMenuSeparator";
